import { render, staticRenderFns } from "./GoldSchemeCreation.vue?vue&type=template&id=2ef40a6b&"
import script from "./GoldSchemeCreation.vue?vue&type=script&lang=js&"
export * from "./GoldSchemeCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports